
















































































































































































































































import Agency from "@/store/entities/agency";
import { Component, Vue } from "vue-property-decorator";
import Currency from "@/store/entities/currency";

@Component({})
export default class AddAgency extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  agency: Agency = new Agency();
  isEdit: boolean = false;
  currencies: Currency[] = [];
  currency: Currency = new Currency();
  
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  async created() {
   await  this.getCurrencies();
    
    this.agency = this.$store.state.agency.editAgency;
    if (this.agency == null) {
      this.isEdit = false;
      this.agency = new Agency();
    } else {
      this.isEdit = true;
      this.currency= this.currencies.find(x=>x.id==this.agency.currencyId);
    }
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }

  async saveAgency() {
    this.agency.currencyId=this.currency.id;
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "agency/saveAgency",
        data: this.agency,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "agency/updateAgency",
        data: this.agency,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }
  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.airport.editAirport = null;
  }
}
